export const SET_GUIDES = 'SET_GUIDES';
export const SET_GUIDE = 'SET_GUIDE';
export const ADD_GUIDE = 'ADD_GUIDE';
export const UPDATE_GUIDE = 'UPDATE_GUIDE';
export const REMOVE_GUIDE = 'REMOVE_GUIDE';
export const CLEAR_GUIDE = 'CLEAR_GUIDE';
export const CLEAR_GUIDES = 'CLEAR_GUIDES';
